
import Vue from "vue"
import { Component } from "vue-property-decorator"

import router from "@/router/router"

Component.registerHooks(["beforeRouteEnter"])

@Component({})
export default class ReportsMainView extends Vue {
    beforeRouteEnter(to: any, from: any, next: any) {
        const regex = new RegExp("^/sections/masterdata/supplier/?$")
        const result = (to.path as string).match(regex)

        if (result) {
            router.push({ path: "/sections/masterdata/supplier/list" })
        } else {
            next()
        }
    }
}
